import { show } from "@ebay/nice-modal-react";
import type { useSingleton } from "@tippyjs/react";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import { VoteButtonTimer } from "@/appInterface/windows/VoteWindow/VoteButtonTimer";
import { canv } from "@/canv/global";
import { VoteIcon } from "@/icons";
import { headerActiveButtonAtom, voteTimerVisibilityAtom } from "@/interface/AppStore";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { BuyProModal } from "@/interface/ui/modals/BuyProModal";
import { Tooltip } from "@/interface/ui/Tooltip";

type VoteProps = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    disabledClass: string;
    className?: string;
};

export const Vote = ({ singletoneTarget, disabledClass, className }: VoteProps) => {
    const { t } = useTranslation();
    const isTimerVisible = useAtomValue(voteTimerVisibilityAtom);
    const activeButtonName = useAtomValue(headerActiveButtonAtom);

    const isFreeUser = !canv.getInitDataProp("isProfessional");

    const handleProUserClick = () => {
        if (canv.appInterface.commentsWindow.opened) {
            canv.appInterface.commentsWindow.close();
        }

        if (canv.canvasController.activeVote) {
            canv.appInterface.activeVote.open();
        } else {
            canv.appInterface.voteWindow.toggle();
        }
    };

    const handleFreeUserClick = () => {
        show(BuyProModal, { feature: "vote" });
    };

    if (isFreeUser) {
        return (
            <BottomBarItem
                className={className}
                active={activeButtonName === "vote" || canv.canvasController.activeVote}
                onClick={handleFreeUserClick}
            >
                <VoteIcon className={disabledClass} />
            </BottomBarItem>
        );
    }

    return (
        <Tooltip singleton={singletoneTarget} content={t("vote.title")}>
            <BottomBarItem
                className={className}
                active={activeButtonName === "vote" || canv.canvasController.activeVote}
                onClick={handleProUserClick}
            >
                <VoteIcon />
                {isTimerVisible && canv.canvasController.activeVote?.UID && (
                    <VoteButtonTimer
                        startedAt={canv.canvasController.activeVote.start}
                        duration={canv.canvasController.activeVote.duration}
                        onUnmount={canv.appInterface.voteWindow.resetTimer}
                    />
                )}
            </BottomBarItem>
        </Tooltip>
    );
};
